/**
 * 门户返回默认配置数据
 */
export const home = [
  {
    "primaryLiBg": {
      "data": {
        "stops": [
          [
            "rgba(255,255,255,1)",
            0
          ],
          [
            "rgba(255,255,255,0.8)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(255,255,255,1)",
      "type": "color",
      "label": "颜色"
    },
    "selectBgColor": {
      "data": {
        "stops": [
          [
            "rgba(255, 255, 255, 0.8)",
            0
          ],
          [
            "rgba(255, 255, 255, 0.8)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(255, 255, 255, 0.8)"
    },
    "hoverLiBg": {
      "data": {
        "stops": [
          [
            "rgba(243,243,246,1)",
            0
          ],
          [
            "rgba(255, 255, 255, 1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(243,243,246,1)",
      "type": "color",
      "label": "颜色"
    },
    "selectBorderColor": {
      "data": {
        "stops": [
          [
            "rgba(231,231,233,1)",
            0
          ],
          [
            "rgba(61,130,242,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(231,231,233,1)",
      "type": "color",
      "label": "颜色"
    },
    "selectLiBg": {
      "data": {
        "stops": [
          [
            "rgba(243,243,246,1)",
            0
          ],
          [
            "rgba(240, 243, 250, 1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(243,243,246,1)",
      "type": "color",
      "label": "颜色"
    },
    "liBorderColor": {
      "data": {
        "stops": [
          [
            "rgba(231,231,233,1)",
            0
          ],
          [
            "rgba(61,130,242,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(231,231,233,1)",
      "type": "color",
      "label": "颜色"
    },
    "width": 130,
    "height":36,
    "borderBottomLeftRadius": 4,
    "borderBottomRightRadius": 4,
    "borderTopRightRadius": 4,
    "borderTopLeftRadius": 4,
    "liBorderBottomLeftRadius": 4,
    "liBorderBottomRightRadius": 4,
    "liBorderTopRightRadius": 4,
    "liBorderTopLeftRadius":4,
    "selectFontColor": "rgba(14, 23, 38, 1)",
    "placeHolderFontColor": "rgba(14, 23, 38, 1)",
    "selectBorderWidth": [1,1,1,],
    "liFontColor": "rgba(14, 23, 38, 1)",
    "hasSearch": false,
    "name": "样式1",
    "cover": require("../../../assets/images/leftMenu/select/style1.png"),
  }
]

/**
 * 大屏返回默认配置数据
 */
export const bs = [{
  liBorderWidth: 0, //下拉列表项边框宽度
  selectLiBg: "#1E2939",
  hoverLiBg: "#1E2939",
  hoverLiColor: "rgba(255,255,255,1)",
}]

/**
 * app下拉默认配置数据
 */
export const appHome = [
  {
    "primaryLiBg": {
      "data": {
        "stops": [
          [
            "rgba(255,255,255,1)",
            0
          ],
          [
            "rgba(255,255,255,0.8)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(255,255,255,1)",
      "type": "color",
      "label": "颜色"
    },
    "selectBgColor": {
      "data": {
        "stops": [
          [
            "rgba(255, 255, 255, 0.8)",
            0
          ],
          [
            "rgba(255, 255, 255, 0.8)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(255, 255, 255, 0.8)"
    },
    "hoverLiBg": {
      "data": {
        "stops": [
          [
            "rgba(243,243,246,1)",
            0
          ],
          [
            "rgba(255, 255, 255, 1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(243,243,246,1)",
      "type": "color",
      "label": "颜色"
    },
    "selectBorderColor": {
      "data": {
        "stops": [
          [
            "rgba(231,231,233,1)",
            0
          ],
          [
            "rgba(61,130,242,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(231,231,233,1)",
      "type": "color",
      "label": "颜色"
    },
    "selectLiBg": {
      "data": {
        "stops": [
          [
            "rgba(243,243,246,1)",
            0
          ],
          [
            "rgba(240, 243, 250, 1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(243,243,246,1)",
      "type": "color",
      "label": "颜色"
    },
    "liBorderColor": {
      "data": {
        "stops": [
          [
            "rgba(231,231,233,1)",
            0
          ],
          [
            "rgba(61,130,242,1)",
            1
          ]
        ],
        "angle": 0
      },
      "color": "rgba(231,231,233,1)",
      "type": "color",
      "label": "颜色"
    },
    "width": 130,
    "height":36,
    "borderBottomLeftRadius": 4,
    "borderBottomRightRadius": 4,
    "borderTopRightRadius": 4,
    "borderTopLeftRadius": 4,
    "liBorderBottomLeftRadius": 4,
    "liBorderBottomRightRadius": 4,
    "liBorderTopRightRadius": 4,
    "liBorderTopLeftRadius":4,
    "selectFontColor": "rgba(14, 23, 38, 1)",
    "placeHolderFontColor": "rgba(14, 23, 38, 1)",
    "selectBorderWidth": [1,1,1,],
    "liFontColor": "rgba(14, 23, 38, 1)",
    "hasSearch": false,
    "name": "样式1",
    "cover": require("../../../assets/images/leftMenu/select/style1.png"),
  }
]
